import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';
import { LOADING, COMPLETE, PAYROLLS_GET_OK } from './types';
import { call } from './../utilities/http';

const defaultState = {
    list: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case PAYROLLS_GET_OK:
            return { ...state, list: action.data };

        default:
            return state;
    }
}

export function getPayrolls(role, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getPayrolls'} defaultMessage={'Unable to retrieve payrolls.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        const { id, type } = role;
        if (!id || !type) {
            Snackbar.error(errorMessage);
            dispatch({ type: COMPLETE });
            return;
        }

        call({ path: `/${type}/${id}/transfers?type=payroll` })
            .then(response => {
                dispatch({ type: PAYROLLS_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getPayrollDetails(payrollId, queryParams, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.getInvoiceTimesheets'} defaultMessage={'Unable to retrieve invoice with timesheets.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/payroll/${payrollId}`, queryParams })
            .then(response => {
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/payrolls.jsx